const memberConfig = {
    member: {
        filterLayout: 'MemberFilterDefaultLayout',
        listLayout: 'MemberListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            m_type: 'normal',
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getMemberList',
    },
    writeMember: {
        writeLayouts: ['MemberWriteDefaultLayout'],
        writeFunc: 'createMember',
        writeApiParamSet: {
            m_type: 'normal',
        },
        getCategoryFunc: '',
        parsingData: {
            mb_id: 'mb_id',
            mb_introduce: 'mb_introduce',
            // mb_name: 'mb_name',
            mb_nick: 'mb_nick',
            mb_sex: 'mb_sex',
            // mb_age: 'mb_age',
            mb_birth: 'mb_birth',
            mb_height: 'mb_height',
            mb_weight: 'mb_weight',
            mb_is_testor: 'mb_is_testor',
            mb_password: 'mb_password',
            mb_color: 'mb_color',
            mb_memo: 'mb_memo',
        },
        keyName: 'mb_no',
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '회원 등록에 실패하였습니다.',
        isUpdateSurvey: true,
        allSetData: true,
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'profile',
                fileType: 'profile',
                required: false,
                validatorMsg: '프로필 이미지를 추가해주세요.',
            },
        ],
    },
    updateMember: {
        getFunc: 'getMemberList',
        detailApiParamSet: {
            ip: 0,
            opf: 1,
            m_type: 'normal',
        },
        getCategoryFunc: 'getMagazineCategory',
        isCategory: true,
        writeFunc: 'updateMember',
        writeLayouts: ['MemberWriteDefaultLayout'],
        writeApiParamSet: {
            m_type: 'normal',
        },
        parsingData: {
            // mb_id: 'mb_id',
            mb_introduce: 'mb_introduce',
            // mb_name: 'mb_name',
            order_mb_name: 'mb_name',
            order_mb_hp: 'mb_hp',
            mb_nick: 'mb_nick',
            // mb_sex: 'mb_sex',
            mb_birth: 'mb_birth',
            // mb_age: 'mb_age',
            mb_height: 'mb_height',
            mb_weight: 'mb_weight',
            mb_is_testor: 'mb_is_testor',
            mb_memo: 'mb_memo',
            mb_color: 'mb_color',
            mb_part: 'mb_part',

            mb_face: 'mb_face',
            mb_skin: 'mb_skin',
            mb_job: 'mb_job',
            // mb_job_extra: this.mb_job_extra ? this.mb_job_extra : '',
            mb_job_extra: 'mb_job_extra',
            mb_mat_shoulder: 'mb_mat_shoulder',
            mb_mat_middle: 'mb_mat_shoulder',
            mb_mat_top: 'mb_mat_top',
            mb_mat_bottom: 'mb_mat_bottom',
            mb_body: 'mb_body',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '회원 등록에 실패하였습니다.',
        isUpdateSurvey: false,
        allSetData: true,
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        keyName: 'mb_no',
        fileInfo: [
            {
                fileName: 'profile',
                fileType: 'profile',
                required: false,
                validatorMsg: '프로필 이미지를 추가해주세요.',
            },
        ],
        deleteFunc: 'deleteMember',
        deleteApiParamsSet: {
            m_type: 'normal',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    profile: {
        filterLayout: 'MemberFilterProfileLayout',
        listLayout: 'MemberListProfileLayout',
        paginationLayout: 'PaginationDeleteLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            pt: 'member',
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getProfile',
        directUrl: '',
        directType: '',
        keyName: 'p_idx',
        deleteFunc: 'deleteProfile',
        deleteApiParamsSet: {
            p_type: 'member',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    writeProfile: {
        writeLayouts: ['MemberWriteProfileLayout'],
        writeFunc: 'createProfile',
        writeApiParamSet: {
            p_type: 'member',
        },
        parsingData: {
            p_title: 'p_title',
            p_is_display: 'p_is_display',
            profileOutline: 'profileOutline',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '이미지를 등록할 수 없습니다.',
        fileUploadFailMsg: '이미지 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'profileOutline',
                fileType: 'profileOutline',
                required: false,
                validatorMsg: '프로필 테두리 이미지를 추가해주세요.',
            },
        ],
    },
    updateProfile: {
        getFunc: 'getProfile',
        detailApiParamSet: {
            pt: 'member',
        },
        writeFunc: 'updateProfile',
        writeLayouts: ['MemberWriteProfileLayout'],
        writeApiParamSet: {
            p_type: 'member',
        },
        parsingData: {
            p_title: 'p_title',
            p_is_display: 'p_is_display',
            // profileOutline: 'profileOutline',
        },
        keyName: 'p_idx',
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '이미지를 등록할 수 없습니다.',
        fileUploadFailMsg: '이미지 등록에 실패하였습니다.',
        fileInfo: [
            {
                fileName: 'profileOutline',
                fileType: 'profileOutline',
                required: false,
                validatorMsg: '프로필 테두리 이미지를 추가해주세요.',
            },
        ],
        deleteFunc: 'deleteProfile',
        deleteApiParamsSet: {
            p_type: 'member',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    deny: {
        filterLayout: 'MemberFilterDenyLayout',
        listLayout: 'MemberListDenyLayout',
        paginationLayout: 'PaginationDefaultLayout',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            m_type: 'out',
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getMemberList',
        isCategory: true,
        getCategoryFunc: 'getMemberOutCategory',
        categoryApiParamSet: {
            moc_type: 'normal',
            moc_is_use: 1
        },
    },
    // log: {
    //     filterLayout: 'MemberFilterLogLayout',
    //     listLayout: 'MemberListLogLayout',
    //     paginationLayout: 'PaginationDefaultLayout',
    //     listApiParamSet: {
    //         ip: 1,
    //         sp: 10,
    //         page: 1,
    //     },
    //     pageRow: 10,
    //     paginationType: 'pagination',
    //     getFunc: 'getMemberLog',
    // },
    updateAdmin: {
        getFunc: '',
        detailApiParamSet: {
        },
        writeFunc: 'updateMember',
        writeLayouts: ['MemberWriteAdminLayout'],
        writeApiParamSet: {
            m_type: 'admin'
        },
        parsingData: {
            mb_name: 'mb_name',
            mb_hp: 'mb_hp',
            mb_email : 'mb_email',
        },
        directUrl: '',
        directType: 'admin',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '수정 할 수 없습니다.',
        fileUploadFailMsg: '파일 등록에 실패하였습니다.',
        keyName: 'ci_idx',
        fileInfo: [
            {
                fileName: 'profile',
                fileType: 'profile',
                required: false,
                validatorMsg: '프로필 이미지를 추가해주세요.',
            },
        ],
    }
}

export default {
    methods: {
        returnMemberConfig(type) {
            return memberConfig[type];
        },
    },
    filterConfig: {
        mid: { //아이디
            type: 'query',
            classname: 'searchInput',
        },
        id: { // 회원 로그 아이디
            type: 'query',
            classname: 'searchInput',
        },
        ni: { //닉네임
            type: 'query',
            classname: 'searchInput',
        },
        na: { //이름, //주문자
            type: 'query',
            classname: 'searchInput',
        },
        la: { // 접속일
            type: 'between',
            classname: 'filterDate',
        },
        cr: { // 회원가입일, 탈퇴기간
            type: 'between',
            classname: 'filterCreate',
        },
        iste: { // 등급
            type: 'match',
            classname: 'filterRank',
        },
        se: { // 성별
            type: 'match',
            classname: 'filterSe',
        },
        isse: { // 탈퇴 유형
            type: 'match',
            classname: 'filterStatus',
        },
        moid: { // 탈퇴 사유
            type: 'match',
            classname: 'filterCate',
        },
        ld: { // 회원 활동 내역
            type: 'between',
            classname: 'filterDate',
            option: {
                start: 's_date',
                end: 'e_date'
            },
        },
        ti: { // 테두리 이름 검색
            type: 'match',
            classname: 'searchInput',
        },
        isdi: { // 노출 상태
            type: 'match',
            classname: 'filterStatus',
        },
        oid : { //주문번호
            type: 'query',
            classname: 'searchInput',
        },
        ina : { //상품명
            type: 'query',
            classname: 'searchInput',
        },
        mo : { //관리코드
            type: 'query',
            classname: 'searchInput',
        },
        pna : { //입금자
            type: 'query',
            classname: 'searchInput',
        },
        or : { //결제일
            type: 'between',
            classname: 'filterDate',
        },
        ps : {//결제금액시작
            type : 'match',
            classname : 'filterPrice_sd'
        },
        pe : {//결제금액끝
            type : 'match',
            classname : 'filterPrice_ed'
        },
        st : { //상태
            type : 'terms',
            classname : 'filterStatus'
        },
    },
}
